import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Heading from '../../components/Common/Heading';
import Guide from '../../components/Common/Guide';
import SubmitButton from '../../components/Common/SubmitButton';
import { forgotPassword } from './services/password.service';


const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await forgotPassword(email, setEmail, setLoader);
  };

  return (
    <div className="App">
      <NavigationBar />
      <div className="bg-storytan p-4 mx-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen">
          <div className=" flex items-center align-end mb-4">
            <Heading title="Forgot Password" />
            <div>
              <Guide />
            </div>
          </div>
          <form
            id="form-reset-password"
            name="form-reset-password"
            className="mt-8 text-start"
            onSubmit={handleSubmit}
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="Enter Your Registered Email"
              className="mt-4 p-2 w-full rounded-md "
              required
            />

            <SubmitButton
              title="Send Password Reset Link"
              loader={loader}
              cancelOperation={() => navigate(-1)}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
